module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1095.f1c6ea42.png";